import styled from '@emotion/styled'
import {
	Box,
	FormGroup,
	TextField,
	type Theme,
	Typography,
} from '@mui/material'

import { CloseIcon } from '../../../assets/icons'

const DrawerFiltersWrapper = styled(Box)`
	padding: 20px 20px 0 20px;
	width: 400px;
	background-color: ${({ theme }: { theme: Theme }) =>
		theme.palette.background.paper};
	position: relative;
`

const FormGroupWrapper = styled(FormGroup)`
	margin-bottom: 30px;
	width: 100%;
`

const Header = styled(Typography<'div'>)`
	text-align: left;
	width: 100%;
	font-weight: 500;
	font-size: 22px;
	line-height: 27px;
`

const Divider = styled.hr`
	width: calc(100% + 40px);
	margin-left: -20px;
	border: 1px solid ${({ theme }: { theme: Theme }) => theme.palette.divider};
	margin-bottom: 20px;
	margin-top: 0;
`

const SectionHeader = styled(Typography<'div'>)`
	font-weight: 700;
	font-size: 16px;
	line-height: 19px;
	margin-left: 5px;
	margin-bottom: 10px;
`

const CloseIconWrapper = styled(CloseIcon)`
	cursor: pointer;
`

const SectionContent = styled(Box)`
	display: flex;
	flex-direction: column;
	margin-left: 10px;
`

const ActionButtons = styled(Box)`
	position: sticky;
	bottom: 0;
	background-color: ${({ theme }: { theme: Theme }) =>
		theme.palette.background.paper};
	width: calc(100% + 40px);
	padding-bottom: 20px;
	padding-right: 20px;
	margin-left: -20px;
`

const CustomTextField = styled(TextField)`
	width: 100px;
	.MuiInputBase-root {
		height: 45px;
		border: 2px solid ${({ theme }: { theme: Theme }) => theme.palette.divider};
		border-radius: 0;
	}
`

export {
	ActionButtons,
	CloseIconWrapper,
	CustomTextField,
	Divider,
	DrawerFiltersWrapper,
	FormGroupWrapper,
	Header,
	SectionContent,
	SectionHeader,
}
